import axios from "axios";
import { assignToken } from "@/components/button/ButtonConnect";
import { Provider } from "../store";

const call = (
  url,
  method,
  withToken = true,
  data = {},
  skipTimestampCheck,
  headers
) => {
  const accessToken = localStorage.getItem("token");

  const currentTimestamp = new Date().getTime() / 1000;
  const expiredTimestamp =
    Number(localStorage.getItem("expiretime")) || Number.MAX_SAFE_INTEGER;

  if (
    !skipTimestampCheck &&
    withToken &&
    (currentTimestamp > expiredTimestamp ||
      !(window.ethereum && window.ethereum?.selectedAddress))
  ) {
    return new Promise((resolve, reject) => {
      reject(`Access token expired or no address provided. `);

      // TODO: Get new auth token here, but how do we access or dispatch to the state from here without passing in `state` on every API call??
    });
  }

  let header = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (withToken) {
    header["Authorization"] = `Bearer ${accessToken}`;
  }

  const options = {
    url,
    method,
    headers: header,
    crossDomain: true,
    data,
  };

  if (headers) {
    options.headers = {
      ...options.headers,
      ...headers,
    };
  }

  return axios
    .request(options)
    .then((res) => res.data)
    .catch((error) => {
      console.log("Error:", error);
      return error.response?.data || error.response;
    });
};

export default call;
